export * from "./FastColor";
export * from "./types";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/fast-color/es/index.js
// module id = 42
// module chunks = 0